/**
 * One-click local QA surface for the Hollow Keeper encounter.
 *
 * `/qa/hollow-keeper` boots the real Coil Undercroft in the clean gameplay
 * preset. NetworkManager then sends the `qaScenario` value once, after the
 * room has connected. The server is the authority for the ephemeral level,
 * quest, and arena-floor spawn setup.
 *
 * The HomeModePicker hides this card on production surfaces, and DebugHandler
 * independently requires MEMORY_ONLY_MODE plus GM permission before changing
 * any session state.
 */
import type { ModeUrlConfig } from '../boot/coerceModeUrl';
import {
  HOLLOW_KEEPER_QA_SCENARIO,
  HOLLOW_KEEPER_QA_SETUP,
} from '../../shared/qa/QaScenario';

export const HOLLOW_KEEPER_QA_ROUTE = '/qa/hollow-keeper' as const;

export const HOLLOW_KEEPER_QA_CONFIG: ModeUrlConfig = {
  resetOnLoad: true,
  preset: 'live-lobby',
  skipSplash: true,
  skipLogin: true,
  autoClass: 'warrior',
  testhooks: true,
  qaScenario: HOLLOW_KEEPER_QA_SCENARIO,
};

export const HOLLOW_KEEPER_QA_MAP_ID = HOLLOW_KEEPER_QA_SETUP.mapId;
